import { Model } from "../lib";

export default class Carrier extends Model {
  urlRoot = "/carriers";
}
